import GameScreen from '../components/GameScreen';
import JudgeVoting from '../components/JudgeVoting';

function JudgeVotingScreen({
  gameName,
  roomCode,
  onReconnect,
  onQuit,
  votingResponses,
  playerId,
  onSubmitVote,
  votingTimeLeft,
  disableTimers,
}) {
  const timerSeconds = !disableTimers ? votingTimeLeft : 0;

  return (
    <GameScreen
      gameName={gameName}
      roomCode={roomCode}
      onReconnect={onReconnect}
      onQuit={onQuit}
      timerSeconds={timerSeconds}
    >
      <JudgeVoting
        votingResponses={votingResponses}
        playerId={playerId}
        onSubmitVote={onSubmitVote}
      />
    </GameScreen>
  );
}

export default JudgeVotingScreen;
